module.exports = __webpack_public_path__ + "static/media/backButton.1e757567.svg";